import { specialCollectionsApi } from "@api/specialCollections";

export const IS_LOADING = "fetchSpecialCollectionDetails/IS_LOADING";
export const SUCCESS = "fetchSpecialCollectionDetails/SUCCESS";
export const HAS_ERROR = "fetchSpecialCollectionDetails/HAS_ERROR";

export const fetchSpecialCollectionDetails = (pid) => {
  return async (dispatch) => {
    dispatch({
      type: IS_LOADING,
    });

    try {
      const response = await specialCollectionsApi.get(pid);
      dispatch({
        type: SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: HAS_ERROR,
        payload: error,
      });
    }
  };
};
